<template>
    <div class="grid grid-cols-12 gap-4 md:gap-6 md:py-2">
        <div v-if="loadedProduct" class="col-span-12 md:col-span-8" />
        <div class="col-span-12 md:col-span-4">
            <LayoutBreadcrumb class="mt-2 md:mt-4 mb-0 md:mb-0" />
        </div>
    </div>
</template>

<script setup lang="ts">
type ProductContext = ReturnType<typeof useProduct>['product']

// Catch in case element is used on non product pages
let loadedProduct: ProductContext | undefined
try {
    const { product } = useProduct()
    loadedProduct = product
} catch {
    loadedProduct = undefined
}
</script>
